import { ExternalLink, Mail, MessageCircle, Phone } from 'lucide-react'
import type { ReactNode } from 'react'
import type { ButtonType } from './supabase/scanReachTypes'

export function getButtonIcon(actionType: ButtonType): ReactNode {
  // Convert into an object to guarantee we always have all the options
  const actionIcon: Record<ButtonType, ReactNode> = {
    tel: <Phone className="h-4 w-4" />,
    mailto: <Mail className="h-4 w-4" />,
    sms: <MessageCircle className="h-4 w-4" />,
    url: <ExternalLink className="h-4 w-4" />,
  }

  return actionIcon[actionType]
}

export function handleButtonClick(actionType: ButtonType, actionValue: string): string {
  const actionButtonClick: Record<ButtonType, string> = {
    tel: `tel:${actionValue}`,
    mailto: `mailto:${actionValue}`,
    sms: `sms:${actionValue}`,
    url: actionValue,
  }

  return actionButtonClick[actionType]
}

export function formatContent(content: string | null) {
  if (!content) {
    return null
  }

  // Enhanced text formatting with bold, italic, underline support
  const formattedText = content
    // Bold: **text** or __text__
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/__(.*?)__/g, '<strong>$1</strong>')
    // Italic: *text*
    .replace(/(?<!\*)\*([^*]+)\*(?!\*)/g, '<em>$1</em>')
    // Underline: _text_
    .replace(/(?<!_)_([^_]+)_(?!_)/g, '<u>$1</u>')
    // Line breaks
    .replace(/\n/g, '<br>')

  return (
    <div
      // biome-ignore lint/security/noDangerouslySetInnerHtml: <@TODO CHECK>
      dangerouslySetInnerHTML={{ __html: formattedText }}
      className="text-base leading-relaxed"
    />
  )
}
